export { NextBackgroundImage } from './NextBackgroundImage';
export { NextIcon } from './NextIcon';
export type { NextBackgroundImageProps } from './NextBackgroundImage';
export type { NextIconProps } from './NextIcon';
